import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute,Router, RouterModule } from '@angular/router';
import { IconModule, ButtonModule, TilesModule, StructuredListModule } from 'carbon-components-angular';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { catchError, forkJoin, of, take } from 'rxjs';
import { MatDialogComponent } from 'src/app/mat-dialog/mat-dialog.component';
import { AppService } from 'src/app/services/app.service';
import { StyleSettingsDealerImage, StyleSettingsResponse, Client, StyleSettingTitles, ApprovalStatusLowerCase } from 'src/app/services/client.service';
import { DownloadPdfService } from 'src/app/services/download-pdf.service';
import { TourGuideDialogComponent } from 'src/app/tour-guide-dialog/tour-guide-dialog.component';
import { SchedulingOrderAuthComponent } from '../../scheduling-order-auth/scheduling-order-auth/scheduling-order-auth.component';
import { MatSnackBarComponent } from 'src/app/mat-snack-bar/mat-snack-bar.component';
import { FeatureFlagService } from 'src/app/services/feature-flag.service';

@Component({
  selector: 'app-scheduling-order-home',
  standalone: true,
  imports: [MatExpansionModule,
        MatIconModule,
        MatDialogModule,
        MatCardModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        MatDividerModule,
        CommonModule,
        IconModule,
        ButtonModule,
        TilesModule,
        NgxExtendedPdfViewerModule,
        MatTabsModule,
        StructuredListModule,
        MatButtonModule,
        MatSnackBarModule,
        MatMenuModule,
        RouterModule,
        SchedulingOrderAuthComponent],
  templateUrl: './scheduling-order-home.component.html',
  styleUrl: './scheduling-order-home.component.scss'
})
export class SchedulingOrderHomeComponent {
  downloadPDFText: string = $localize`Report PDF`;
  downloadPDFInfoText: string = $localize`Download report PDF`;
  pendingIssuesText: string = $localize`Authorization requests`;
  PendingIssuesInfoText: string = $localize`Please review the identified issues.Pending requests requires your authorization`;
  
    value: any = null;
    authorized = 0;
    declined = 0;
    needAuthorization = 0;
    pdfBase64Data: string = '';
    isPDFDataAvailable: boolean = true;
    token: string = '';
    isLargeScreen: boolean = window.innerWidth > 900;
    isScreenSize:boolean=window.innerWidth > 900;
    apiResponse: any;
    isDownloading = false;
    downloadCompleted = false;
    dealerImageDetails: StyleSettingsDealerImage | undefined;
    siteSettings: StyleSettingsResponse | undefined;
    currentStepperPosition: number | undefined;
    @ViewChild('downloadPDFTour') downloadPDFTour!: ElementRef;
    @ViewChild('pendingIssues') pendingIssues!: ElementRef;
    @ViewChild('checkedOk') checkedOk!: ElementRef;
    totalSteps: number = 3;
    authComponentCalls : boolean = false;
    ApprovalstatusLowerCase = ApprovalStatusLowerCase;
    isAllowed = true;
  
    constructor(public dialog: MatDialog, private readonly router: Router, private readonly route: ActivatedRoute, private readonly pdfService: DownloadPdfService, public appService: AppService, private readonly client: Client, @Inject(PLATFORM_ID) private platformId: Object,private snackBar: MatSnackBar,private featureFlagService: FeatureFlagService) { }
  
ngOnInit(): void {
  this.checkScreenSize();

  this.route.queryParams.subscribe(params => {
    this.token = params['token'];

    this.featureFlagService.getFeatures(this.token, 'Scheduling-Order-Report')
      .then(allowed => {
        if (!allowed) {
          this.isAllowed = false;
          this.snackBar.openFromComponent(MatSnackBarComponent, {
            data: `The feature "Scheduling Report" is currently not enabled in MW Admin Portal - Feature Management. Please contact support for more information.`,
            duration: 10000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
          });
          return;
        }
        this.getSchedulingReport(this.token);
        this.loadChecklistData();
      })
      .catch(() => {
        this.isAllowed = false;
      });
  });
}
  
    onChecklistUpdate(): void {
      if (this.isLargeScreen) {
        this.authComponentCalls = true;
        this.calculateChecklistSummary();
      }
    }
  
    openWelcomeDialog() {
      const localLang = localStorage.getItem('lang')
      if (localLang == null) {
        const dialogRef = this.dialog.open(MatDialogComponent, {
          data: {
            type: 'LanguageDialog',
          },
        });
  
        dialogRef.afterClosed().subscribe(result => {
          this.welcomeDialog(this.apiResponse.schedulingDetails.customer.name);
        });
      } else {
        this.appService.setDefaultLanguage();
        this.welcomeDialog(this.apiResponse.schedulingDetails.customer.name);
      }
  
      if(this.isScreenSize==false)
      {
      this.appService.tourGuideStepPosition$.subscribe((position: number) => {
        if (position !== undefined) {
          this.currentStepperPosition = position
        }
        if (position > 0) {
          let targetElementRect
          const dialogConfig = new MatDialogConfig()
          if (position === 1) {
            this.appService.languaTourGuide('service-order');
          } else if (position === 2) {
            targetElementRect = this.downloadPDFTour.nativeElement.getBoundingClientRect();
            this.downloadPDFTour.nativeElement.classList.add('tour-dialog-indication');
            dialogConfig.data = {
              title: this.downloadPDFText,
              desciption: this.downloadPDFInfoText,
              stepCount: 2,
              totalSteps: this.totalSteps,
              position: targetElementRect
            }
            this.startVhcTour(dialogConfig);
          } else if (position === 3) {
            targetElementRect = this.pendingIssues.nativeElement.getBoundingClientRect();
            this.pendingIssues.nativeElement.classList.add('tour-dialog-indication');
            dialogConfig.data = {
              title:this.pendingIssuesText,
              desciption: this.PendingIssuesInfoText,
              stepCount: 3,
              totalSteps: this.totalSteps,
              position: targetElementRect
            };
            this.startVhcTour(dialogConfig);
          }
        }
      });
    }
    }
  
    @HostListener('window:resize', [])
    onResize() {
      this.checkScreenSize();
    }
  
    loadChecklistData() {
      if (!this.token) {
        return;
      }
  
      this.appService.schedulingDetails$ = undefined;
      this.appService.companySetting$ = undefined;
      this.appService.getDealerMediaResponse$ = undefined;
  
      forkJoin({
        schedulingDetails: this.appService.geSchedulingDetails(this.token),
        stylesettings: this.appService.getStyleSettings(this.token).pipe(
          catchError(() => {
            return of(null);
          })
        )
      })
        .pipe(take(1))
        .subscribe({
          next: ({ schedulingDetails, stylesettings}) => {
            this.apiResponse = schedulingDetails;
            this.siteSettings = stylesettings;
            this.dealerImageDetails = stylesettings?.dealerImage;
            const tourGuide = sessionStorage.getItem('tourGuide');
            if(tourGuide !== 'true' && !this.authComponentCalls)
            {
              this.openWelcomeDialog();
            }
            this.calculateChecklistSummary();
          },
          error: (error) => {
            const errorMessage = error instanceof Error ? error.message : String(error);
            this.appService.handleErrorMessage(errorMessage);
          }
        });
    }
  
    welcomeDialog(customerName: string | undefined) {
      const title = this.siteSettings?.titles?.find((title: StyleSettingTitles) => {
        return title.page === 'JobConsent' && title.type === 'Welcome' && title.content;
      });
      const Content = title?.content ? this.appService.convertToHtml(title.content) : null;
      if(this.isScreenSize==false){
      const dialogRef = this.dialog.open(MatDialogComponent, {
        data: {
          type: 'VHCReportWelcomeDialog',
          customerName: customerName,
          content: Content
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        sessionStorage.setItem("tourGuide", "true")
        if (result) {
          this.appService.tourGuideStepPosition(1)
        }
      });
      }else{
        const dialogRef = this.dialog.open(MatDialogComponent, {
          data: {
            type: 'VHCReportWelcomeDialogInLargeScreen',
            customerName: customerName,
            content: Content
          },
        });
      }
    }
  
    startVhcTour(dialogConfig: MatDialogConfig) {
      let screenInnerHeight;
      if (isPlatformBrowser(this.platformId)) {
        screenInnerHeight = window.innerHeight
      } else {
        screenInnerHeight = 0
      }
      if (screenInnerHeight > dialogConfig.data.position.bottom) {
        if (screenInnerHeight - dialogConfig.data.position.bottom > 200) {
          dialogConfig.position = {
            top: `${(dialogConfig.data.position.bottom + 5) / 16}rem`,
            left: `${(dialogConfig.data.position.right - 270)/16}rem`,
          };
        }
        else {
          dialogConfig.position = {
            top: `${(dialogConfig.data.position.bottom - 200)/16}rem`,
            left: `${(dialogConfig.data.position.right - 270)/16}rem`,
          };
        }
      }
      else {
        window.scroll({
          top: dialogConfig.data.position.bottom,
          behavior: 'smooth'
        });
        dialogConfig.position = {
          top: `${((screenInnerHeight - dialogConfig.data.position.height) - 210)/16}rem`,
          left: `${(dialogConfig.data.position.right - 270)/16}rem`,
        };
      }
  
      setTimeout(() => {
        const dialogRef = this.dialog.open(TourGuideDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(result => {
          this.downloadPDFTour.nativeElement.classList.remove('tour-dialog-indication');
          this.pendingIssues.nativeElement.classList.remove('tour-dialog-indication');
          this.appService.tourGuideStepPosition(result)
        });
      }, 200);
    }
  
    calculateChecklistSummary(): void {
      this.authorized = 0;
      this.declined = 0;
      this.needAuthorization = 0;
    
      const serviceJobs = this.apiResponse?.schedulingDetails?.serviceJobs ?? [];
    
      serviceJobs.forEach((job: any) => {
        const status = job.approvalStatus?.trim().toLowerCase() || '';
        switch (status) {
          case ApprovalStatusLowerCase.Accept:
            this.authorized++;
            break;
          case ApprovalStatusLowerCase.Reject:
            this.declined++;
            break;
          case '':
          case ApprovalStatusLowerCase.NotProvided:
            this.needAuthorization++;
            break;
        }
      });
    }
    
    navigateToAuthPage() {
      if (this.isLargeScreen) {
        return;
      }
      else {
        this.appService.setSchedulingResponseData(this.apiResponse);
        this.appService.setStylesettings(this.siteSettings);
        this.router.navigate(['/scheduling-order-auth'], {
          queryParams: { ...this.route.snapshot.queryParams }
        });
      }
    }
  
    downloadPdf() {
      if (this.pdfBase64Data) {
        if (!this.downloadCompleted) {
          this.isDownloading = true;
        }
  
        this.pdfService.downloadPdf(this.pdfBase64Data, 'Scheduling-report.pdf', 'application/pdf')
          .then(() => {
            if (!this.downloadCompleted) {
              setTimeout(() => {
                this.isDownloading = false;
                this.downloadCompleted = true;
  
                setTimeout(() => {
                  this.downloadCompleted = false;
                }, 5000);
  
              }, 1000);
            }
          })
          .catch(() => {
            this.isDownloading = false;
            alert('Download failed!');
          });
      } else {
        this.isPDFDataAvailable = false;
         this.snackBar.openFromComponent(MatSnackBarComponent, {
        data: "Report setup is missing for Scheduling Order in DMS.",
        duration: 5000,
        });
      }
    }
  
    getSchedulingReport(token: string) {
      this.appService.getSchedulingOrderPDFReport(token)?.subscribe((data: string) => {
        this.pdfBase64Data = data;
        this.isPDFDataAvailable = true;
      })
    }
  
    checkScreenSize() {
      this.isLargeScreen = window.innerWidth > 900;
    }
}
